import React from "react";
import { useEffect, useState } from "react";
import API from "../api/axiosConfig";
import { useNavigate } from "react-router-dom";
import {
  ClipboardList,
  Heart,
  ShoppingCart,
  User,
  Store,
  Shield,
  Bike,
  LogOut,
  Bell,
  MessageCircle,
  Trophy,
  Gift,
} from "lucide-react";

export default function UserMenu({ user, onClose, logout }) {
  const navigate = useNavigate();
  const [notifCount, setNotifCount] = useState(0);
  const [activeEventCount, setActiveEventCount] = useState(0);

  const go = (path) => {
    onClose?.();
    navigate(path);
  };

  useEffect(() => {
    if (!user) return;

    API.get("/notifications/unread-count")
      .then((res) => setNotifCount(res.data?.data?.count ?? res.data?.count ?? 0))
      .catch(() => {});

    API.get("/events/active")
      .then((res) => {
        const events = res.data?.data?.events ?? [];
        setActiveEventCount(events.length);
      })
      .catch(() => {});
  }, [user]);

  const NotificationItem = () => (
    <button
      onClick={() => {
        onClose?.();
        navigate("/notifications");
      }}
      className="
      flex items-center justify-between
      px-5 py-3 rounded-xl
      text-gray-700 hover:bg-gray-100 transition
    "
    >
      <div className="flex items-center gap-4">
        <Bell size={20} className="text-supernova-500" />
        <span className="font-medium">Notificaciones</span>
      </div>

      {notifCount > 0 && (
        <span
          className="
        bg-red-500 text-white text-xs
        min-w-[20px] h-5 px-2
        rounded-full flex items-center justify-center
        font-semibold
      "
        >
          {notifCount}
        </span>
      )}
    </button>
  );

  const openWhatsApp = () => {
    let message = "Hola, necesito ayuda.";

    if (user) {
      message = `Hola, soy ${user.name} (${user.email}). Mi rol es ${user.role}. Necesito ayuda.`;
    }

    const url = `https://wa.me/584147570074?text=${encodeURIComponent(
      message
    )}`;

    window.open(url, "_blank");
    onClose?.();
  };

  const Item = ({ icon: Icon, label, to }) => (
    <button
      onClick={() => go(to)}
      className="
        flex items-center gap-4 px-5 py-3 
        rounded-xl text-gray-700 
        hover:bg-gray-100 transition
      "
    >
      <Icon size={20} className="text-supernova-500" />
      <span className="font-medium">{label}</span>
    </button>
  );

  return (
    <div className="h-full flex flex-col">
      <div className="bg-gradient-to-br from-supernova-500 to-supernova-600 p-6 text-white">
        {user ? (
          <div className="flex items-center gap-4">
            <img
              src={user.avatar || "/avatar_profile.png"}
              alt="Avatar"
              className="w-14 h-14 rounded-full object-cover border-2 border-white"
            />

            <div>
              <p className="font-semibold leading-tight">{user.name}</p>
              <p className="text-sm text-white/80 capitalize">{user.role}</p>
            </div>
          </div>
        ) : (
          <p className="font-semibold">Bienvenido</p>
        )}
      </div>

      <div className="flex-1 p-4 space-y-1">
        {user ? (
          <>
            <Item icon={User} label="Mi cuenta" to="/myaccount" />
            <Item icon={ClipboardList} label="Mis pedidos" to="/my-orders" />
            <Item icon={Heart} label="Favoritos" to="/favorites" />
            <Item icon={ShoppingCart} label="Mi carrito" to="/cart" />
            <Item icon={Gift} label="Mis premios y cupones" to="/ruleta/premios" />
            {user && <NotificationItem />}

            {/* Eventos */}
            <button
              onClick={() => go("/events")}
              className="flex items-center justify-between px-5 py-3 rounded-xl text-gray-700 hover:bg-gray-100 transition"
            >
              <div className="flex items-center gap-4">
                <Trophy size={20} className="text-supernova-500" />
                <span className="font-medium">Eventos</span>
              </div>
              {activeEventCount > 0 && (
                <span className="bg-supernova-500 text-white text-xs min-w-[20px] h-5 px-2 rounded-full flex items-center justify-center font-semibold animate-pulse">
                  {activeEventCount}
                </span>
              )}
            </button>

            {user.role === "company" && (
              <Item icon={Store} label="Panel empresa" to="/company" />
            )}

            {user.role === "admin" && (
              <Item icon={Shield} label="Panel admin" to="/admin" />
            )}

            {user.role === "ryder" && (
              <Item icon={Bike} label="Panel ryder" to="/ryder" />
            )}
          </>
        ) : (
          <>
            <Item icon={User} label="Ingresar" to="/login" />
            <button
              onClick={() => go("/register")}
              className="
                mt-2 w-full py-3 rounded-xl
                bg-supernova-500 hover:bg-supernova-700
                text-white font-semibold transition
              "
            >
              Registrarse
            </button>
          </>
        )}
      </div>

      {user && (
        <div className="p-4 border-t">
          <button
            onClick={logout}
            className="
              w-full flex items-center justify-center gap-2
              py-3 rounded-xl text-red-600
              hover:bg-red-50 font-semibold transition
            "
          >
            <LogOut size={18} />
            Cerrar sesión
          </button>
        </div>
      )}
      <div className="p-4 border-t">
        <button
          onClick={openWhatsApp}
          className="flex items-center gap-4 px-5 py-3 rounded-xl text-gray-700 hover:bg-green-50 transition"
        >
          <MessageCircle size={20} className="text-green-600" />
          <span className="font-medium">Soporte</span>
        </button>
      </div>
    </div>
  );
}
